/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* Rule for device types
*/
export class V3StackAdaptDeviceTypeRule {
    /**
    * Device types for the rule. Must be one of 'CONNECTED_DEVICE', 'CONNECTED_TV', 'DESKTOP', 'MOBILE_TABLET', 'PHONE', 'SET_TOP', 'TABLET'
    */
    'deviceTypes'?: Array<string>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "deviceTypes",
            "baseName": "deviceTypes",
            "type": "Array<string>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptDeviceTypeRule.attributeTypeMap;
    }

    public constructor() {
    }
}

